import { Metamodel } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { SqlBaseSettings } from 'app/model/dataflow/dataset-settings/sql-base-settings';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';

@Metamodel.model({
    name: adfModelTypeMap.azureSqlMI.dataflowSettings,
    validator: SqlMISettings.validateSettings
})
export class SqlMISettings extends SqlBaseSettings {
    public getFormat(): DatasetFormatType {
        return DatasetFormatType.SqlMI;
    }

    public getIconClass(): string {
        return 'i-100x100-azure_sql_db_managed_instance';
    }

    public initialize(subFormat: string): void {
        super.initialize(subFormat);
        this.store = DatasetFormatType.SqlDB;
    }
}
